import clsx from 'clsx'
import { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { cancelSearch } from '../../features/customer/customerAPI'
import {
    getCustomers,
    LOADING_STATES,
    selectFilteredAccounts,
    setCurrentSearch,
} from '../../features/customer/customerSlice'
import { setSearchCustomerState } from '../../features/order/orderSlice'
import { SearchIcon } from '../../GlobalComponents/_icons/Icons'
import { FastQuoteInput } from '../../GlobalComponents/Inputs/Inputs'
import styles from './CustomerSearch.module.scss'

interface CustomerSearchProps {
    value?: string
    title?: string
    tooltip?: string
    placeholder?: string
    inputRef: any
    onSearch(): void
    onCustomerChange?(accountCode: string): void
}
export default function CustomerSearch(props: CustomerSearchProps) {
    const { onSearch, onCustomerChange, inputRef, value, title, placeholder, tooltip } = props
    const dispatch = useAppDispatch()
    const customers = useAppSelector(selectFilteredAccounts)
    const customersLoading = useAppSelector((state) => state.customer.customersLoading)
    const currentCustomer = useAppSelector((state) => state.customer.currentCustomer)

    const searchValue = useAppSelector((state) => state.customer.currentSearch)

    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        if (currentCustomer?.AccountCode) {
            setInputValue(currentCustomer?.AccountCode.trim())
            onCustomerChange !== undefined && onCustomerChange(currentCustomer?.AccountCode.trim())
        }
    }, [currentCustomer])

    useEffect(() => {
        if (value !== undefined) {
            setInputValue(value)
            dispatch(setCurrentSearch(value))
        }
    }, [value])

    useEffect(() => {
        if (!inputValue) cancelSearch()
    }, [inputValue])

    const handleKeyPress = (e: any) => {
        if (e.key === 'Enter') handleInputChange()
    }

    const handleBlur = () => {
        handleInputChange()
    }

    const handleInputChange = () => {
        if (inputValue.trim() === searchValue.trim()) return

        if (inputValue.trim() === '') {
            clearCustomers()
        } else {
            dispatch(getCustomers(inputValue))
            dispatch(setSearchCustomerState(LOADING_STATES.LOADING))
            onSearch()
        }
    }

    const clearCustomers = () => {
        setInputValue('')
        dispatch(setSearchCustomerState(LOADING_STATES.INIT))
        dispatch(setCurrentSearch(''))
        onCustomerChange !== undefined && onCustomerChange('')
    }

    const hasExactMatch = customers.filter((row) => row.ExactMatch).length > 0
    const isEmailSearch = searchValue.includes('@')
    const loading = customersLoading === LOADING_STATES.LOADING

    return (
        <div className={clsx([styles.container, styles.customerSearch])}>
            <FastQuoteInput
                inputRef={inputRef}
                title={title && <div style={{ display: 'inline' }}>{title}</div>}
                tooltip={tooltip ?? ''}
                Icon={SearchIcon}
                loading={loading}
                onChange={setInputValue}
                onKeyPress={handleKeyPress}
                onBlur={handleBlur}
                value={inputValue}
                placeholder={
                    placeholder ??
                    'Email, Contact Name, Company Name, Account Code, Quote/Order Number, etc.'
                }
                validationText={
                    !loading && !hasExactMatch && isEmailSearch && 'No exact matches found'
                }
                // infoText={loading ? '' : getInfoText(searchValue, hasExactMatch, isEmailSearch)}

                renderEndIcon={() =>
                    inputValue && (
                        <div
                            style={{ width: 18, height: 15 }}
                            className={'a-i-close'}
                            // intentionally mousedown because mousedown triggers parent blur
                            onMouseDown={clearCustomers}
                            data-testid='searchInputClear'
                        />
                    )
                }
                data-testid={'searchInput'}
            />
        </div>
    )
}
